/*@ngInject*/
const DataSetManagementUtil = function (uuidUtil, configurationConstant) {

    this.isValidDataItem = function (dataItem) {
        return !_.isNil(dataItem.name) && dataItem.name !== '' && !_.isNil(dataItem.value) && dataItem.value !== '';
    };

    this.isValidDataItemForEvaluation = function (dataItem) {
        return (!_.isNil(dataItem.name) && dataItem.name !== '') || (!_.isNil(dataItem.value) && dataItem.value !== '');
    };

    this.isEmptyDataItem = function (dataItem) {
        return _.isEmpty(dataItem.name) && _.isEmpty(dataItem.value) && _.isNil(dataItem.defaultPrecedence);
    };

    this.isValidSourceFieldDependency = function (sourceFieldDependency) {
        return !_.isEmpty(sourceFieldDependency.formTemplateUniqueName) && !_.isEmpty(sourceFieldDependency.fieldName);
    };

    this.isValidDynamicDataItemCriteriaForEvaluation = function (dynamicDataItemCriteria) {
        var validValue = !_.isEmpty(dynamicDataItemCriteria.value),
            validProductName = !_.isEmpty(dynamicDataItemCriteria.productName),
            validFieldValue = false;

        _.each(_.range(1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES + 1), function (index) {
            if (!_.isEmpty(dynamicDataItemCriteria['fieldValue' + index])) {
                validFieldValue = true;
                return false;
            }
        });

        return validValue || validProductName || validFieldValue;
    };

    this.isValidDynamicDataItemCriteria = function (dynamicDataItemCriteria) {
        var validValue = !_.isEmpty(dynamicDataItemCriteria.value),
            validProductName = !_.isEmpty(dynamicDataItemCriteria.productName),
            validFieldValue = false;

        _.each(_.range(1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES + 1), function (index) {
            if (!_.isEmpty(dynamicDataItemCriteria['fieldValue' + index])) {
                validFieldValue = true;
                return false;
            }
        });

        return validValue && (validProductName || validFieldValue);
    };

    this.generateUUID = function(){
        return uuidUtil.generateUUID().replace(/-/g, '');
    };

    this.isEntireRowEmptyValidDataItem = function (dataItem) {
        return !_.isNil(dataItem.name) && dataItem.name !== '' && !_.isNil(dataItem.value) && dataItem.value !== '';
    };
};

angular.module('ums.configuration')
    .service('dataSetManagementUtil', DataSetManagementUtil);
